// Import necessary dependencies
import React, { useState, useEffect } from "react";
import "./deleteprofile.css"

function DeleteProfile() {
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isDeleteRequested, setIsDeleteRequested] = useState(false);

  useEffect(() => {
    const storedUsers = JSON.parse(localStorage.getItem("users"));

    if (!storedUsers) {
      localStorage.setItem("users", JSON.stringify(userCredentials));
      setUsers(userCredentials);
    } else {
      setUsers(storedUsers);
    }
  }, []);

  const handleSignup = (e) => {
    e.preventDefault();
    const newUser = { email, password };
    setUsers([...users, newUser]);
    localStorage.setItem("users", JSON.stringify([...users, newUser]));
    setEmail("");
    setPassword("");
  };

  const handleSignIn = (e) => {
    e.preventDefault();
    const foundUser = users.find(
      (user) => user.email === email && user.password === password
    );
    if (foundUser) {
      setIsLoggedIn(true);
    } else {
      alert("Invalid credentials. Please sign up or try again.");
    }
  };

  const handleDeleteAccount = () => {
    const foundUser = users.find(
      (user) => user.email === email && user.password === password
    );
    if (!foundUser) {
      alert("Invalid username or password");
      return
    } 
    const updatedUsers = users.filter((user) => user.email !== email);
    setUsers(updatedUsers);
    localStorage.setItem("users", JSON.stringify(updatedUsers));
    setEmail("");
    setPassword("");
    setIsLoggedIn(false);
    setIsDeleteRequested(true);
  };

  useEffect(() => {
    if (isDeleteRequested) {
      alert("Your deletion request has been submitted successfully!");
      setIsDeleteRequested(false);
    }
  }, [isDeleteRequested]);

  return (
    <div className="app-container">
      {isLoggedIn ? (
        <div>
          <h2 className="welcome-message">Welcome, {email}!</h2>
          <button
            className="delete-account-btn"
            onClick={handleDeleteAccount}
          >
            {isDeleteRequested
              ? "Submit Your Request for Deletion"
              : "Deletion Requested"}
          </button>
        </div>
      ) : (
        <form className="auth-form">
          <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
            <h3 style={{color:"black",textAlign:"center",margin:"0px auto 30px auto"}}>Try On Hairstyles</h3>
            <label className="form-label">
              Email
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </label>
            <label className="form-label">
              Password
              <input
                className="form-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </label>
          </div>
          <button className="auth-btn" onClick={handleDeleteAccount}>
            Submit Request to Delete Account
          </button>
        </form>
      )}
    </div>
  );
}
export default DeleteProfile;


const userCredentials = [
  {
    email: "john.doe@gmail.com",
    password: "Pa$$w0rd1",
    name: "John",
    lastname: "Doe",
  },
  {
    email: "jane.smith@yahoo.com",
    password: "SecurePass2",
    name: "Jane",
    lastname: "Smith",
  },
  {
    email: "robert.johnson@outlook.com",
    password: "StrongP@ss3",
    name: "Robert",
    lastname: "Johnson",
  },
  {
    email: "emily.williams@hotmail.com",
    password: "SafeP@ss4",
    name: "Emily",
    lastname: "Williams",
  },
  {
    email: "michael.brown@gmail.com",
    password: "SecretP@ss5",
    name: "Michael",
    lastname: "Brown",
  },
  {
    email: "olivia.jones@yahoo.com",
    password: "HiddenP@ss6",
    name: "Olivia",
    lastname: "Jones",
  },
  {
    email: "william.taylor@outlook.com",
    password: "ProtectedP@ss7",
    name: "William",
    lastname: "Taylor",
  },
  {
    email: "sophia.anderson@hotmail.com",
    password: "EncryptedP@ss8",
    name: "Sophia",
    lastname: "Anderson",
  },
  {
    email: "daniel.miller@gmail.com",
    password: "ConfidentialP@ss9",
    name: "Daniel",
    lastname: "Miller",
  },
  {
    email: "ava.moore@yahoo.com",
    password: "ClassifiedP@ss10",
    name: "Ava",
    lastname: "Moore",
  },
];
